import { LicenseApiSingleton, validateStatusForCollectionEndpoint } from '@shared/services/license-sdk/LicenseApiSingleton'
import { UserClient, UserInstances } from '@skynamo/license_service_api'
import { defineStore } from 'pinia'
import { useAuthStore } from '@shared/stores/auth'
import { AxiosError } from 'axios'
import { computed, ComputedRef, Ref, ref } from 'vue'

export interface UserInfo {
    initialised: Ref<boolean>,
    clients: Ref<UserClient[]>
    instances: ComputedRef<UserInstances[]>
    update: () => Promise<void>
}

export const useUserInfoStore = defineStore('UserInfoStore', () => {
    const authStore = useAuthStore()

    const initialised = ref(false)
    const clients = ref<UserClient[]>([])
    const instances = computed<UserInstances[]>(() => clients.value.flatMap(client => client.instances ?? []))

    authStore.$subscribe(() => {
        update()
    })
    async function update() {
        if (!authStore.dc) {
            return
        }
        const licenseService = await LicenseApiSingleton.getUsersApiInstance()
        const response = await licenseService.getUserClientsWithInstances(authStore.userId, { validateStatus: validateStatusForCollectionEndpoint })
        if (response instanceof AxiosError) {
            throw response
        }
        const clientsInstances = response.status === 404 ? [] : response.data
        clients.value = clientsInstances.toSorted((clientA, clientB) => {
            const aName = clientA.clientName.toLowerCase()
            const bName = clientB.clientName.toLowerCase()

            if (aName > bName) {
                return 1
            }

            if (aName < bName) {
                return -1
            }

            return 0
        }).map(client => {
            client.instances?.sort((instanceA, instanceB) => {
                const aName = instanceA.instanceName.toLowerCase()
                const bName = instanceB.instanceName.toLowerCase()

                if (aName > bName) {
                    return 1
                }

                if (aName < bName) {
                    return -1
                }

                return 0

            })
            return client
        })
        initialised.value = true
    }

    return <UserInfo>{
        initialised,
        clients,
        instances,
        update,
    }
})